import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  obtenerDirectiva,
  setListadoDirectiva,
  setMessageError,
  setMessageSuccess,
  guardarDirectiva,
  setValidarDirectiva,
  validarDirectiva,
  eliminarCargo,
} from "../../sliceRedux/ValidarReserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import ModalSocios from "./ModalSocios";
import RegistrarCargo from "./RegistrarCargo";
import { Fieldset } from "primereact/fieldset";
import moment from "moment";
import Observation from "../../componentes/Observation";
import { nemonicoEstadoDeshabilitar } from "../../constantes/appConstantes";

const Directiva = (props) => {
  const {
    showLoader,
    hideLoader,
    dispatch,
    stepperRef,
    toast,
    codSolConstitucion,
    codGrupoConstAdec,
    nemEstado,
  } = props;
  const [bandejaDirectiva, setBandejaDirectiva] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalCargo, setModalCargo] = useState(false);
  const [selectedCargo, setSelectedCargo] = useState({});
  const listadoDirectiva = useSelector((state) => state.validar.listadoDirectiva);
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);
  const messageError = useSelector((state) => state.validar.messageError);
  const validarDatosDirectiva = useSelector((state) => state.validar.validarDatosDirectiva);
  const [expandedRows, setExpandedRows] = useState([]);
  const [indexSelect, setIndexSelect] = useState(0);
  const [selectedSocios, setSelectedSocios] = useState([]);
  const [selectedCargos, setSelectedCargos] = useState([]);
  const [disabledContinue, setDisabledContinue] = useState(false);
  const [deshabilitarCampos, setDeshabilitarCampos] = useState(false);
  const disabledNext = bandejaDirectiva
    .filter((item) => item.obligatorio === true)
    .some((item) => item.codSolConstSocios === null || item.codSolConstSocios === undefined);

  useEffect(() => {
    showLoader();
    dispatch(obtenerDirectiva(codSolConstitucion, codGrupoConstAdec));
  }, []);

  useEffect(() => {
    if (listadoDirectiva.code === 200) {
      let estado =
        nemonicoEstadoDeshabilitar.includes(nemEstado) && !listadoDirectiva?.object?.observacion;
      setDeshabilitarCampos(estado);

      let listado = listadoDirectiva?.object?.listCargoDirectiva ?? [];
      listado = [...listado].sort((a, b) =>
        b.nemCatTipoGobierno.localeCompare(a.nemCatTipoGobierno)
      );
      setBandejaDirectiva(listado);
    }

    return () => {
      hideLoader();
      dispatch(setListadoDirectiva({ ...listadoDirectiva, ...{ code: 0 } }));
    };
  }, [listadoDirectiva.code]);

  useEffect(() => {
    if (validarDatosDirectiva.code === 200) {
      stepperRef.current.nextCallback();
    }
    return () => {
      hideLoader();
      dispatch(setValidarDirectiva({ ...validarDatosDirectiva, ...{ code: 0 } }));
    };
  }, [validarDatosDirectiva.code]);

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleModalCargo = () => {
    setModalCargo(!modalCargo);
  };

  const callbackSelected = (rowData) => {
    let datos = [...bandejaDirectiva];
    datos[indexSelect] = { ...datos[indexSelect], ...rowData };
    setBandejaDirectiva(datos);
    modal && toggleModal();
    modalCargo && toggleModalCargo();
  };

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      modal && toggleModal();
      setDisabledContinue(false);
      dispatch(obtenerDirectiva(codSolConstitucion, codGrupoConstAdec));
    }
    return () => {
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const actionTemplate = (rowData, props) => {
    return (
      <>
        {!rowData.codSolConstSocios ? (
          <Button
            icon="pi pi-pencil"
            rounded
            className="mr-1"
            tooltip="Asignar socio"
            severity="secondary"
            tooltipOptions={{ position: "top" }}
            disabled={deshabilitarCampos}
            onClick={() => {
              setIndexSelect(props.rowIndex);
              let codSeleccionados = bandejaDirectiva
                .filter((item) => item.codSolConstSocios)
                .map((item) => item.codSolConstSocios);
              setSelectedSocios(codSeleccionados);
              toggleModal();
              setDisabledContinue(true);
            }}
          />
        ) : (
          <Button
            icon="pi pi-trash"
            rounded
            tooltip="Eliminar socio"
            severity="danger"
            className="mr-1"
            tooltipOptions={{ position: "top" }}
            disabled={deshabilitarCampos}
            onClick={() => {
              let datos = [...bandejaDirectiva];
              datos[props.rowIndex] = {
                ...datos[props.rowIndex],
                codSolConstSocios: null,
                numIdentificacion: "",
                nombres: "",
              };
              setBandejaDirectiva(datos);
              setDisabledContinue(true);
            }}
          />
        )}
        {rowData.requiereDirectiva && (
          <>
            {!rowData.codParamCargoGrupSocDirectv && rowData.codSolConstSocios ? (
              <Button
                icon="pi pi-user-plus"
                rounded
                tooltip="Asignar cargo"
                className="mr-1"
                tooltipOptions={{ position: "top" }}
                disabled={deshabilitarCampos}
                onClick={() => {
                  setIndexSelect(props.rowIndex);
                  setSelectedCargo(rowData);
                  toggleModalCargo();
                  setDisabledContinue(true);
                  let codSeleccionados = bandejaDirectiva
                    .filter(
                      (item) =>
                        item.codParamCargoGrupSocDirectv &&
                        item.nemCatTipoGobierno === rowData.nemCatTipoGobierno
                    )
                    .map((item) => item.codParamCargoGrupSocDirectv);
                  setSelectedCargos(codSeleccionados);
                }}
              />
            ) : (
              rowData.codParamCargoGrupSocDirectv && (
                <Button
                  icon="pi pi-user-minus"
                  rounded
                  tooltip="Eliminar cargo"
                  severity="danger"
                  className="mr-1"
                  tooltipOptions={{ position: "top" }}
                  disabled={deshabilitarCampos}
                  onClick={() => {
                    if (rowData.codConstSocioCargoDirectv) {
                      showLoader();
                      dispatch(eliminarCargo(rowData.codConstSocioCargoDirectv));
                    } else {
                      let datos = [...bandejaDirectiva];
                      datos[props.rowIndex] = {
                        ...datos[props.rowIndex],
                        codConstSocioCargoDirectv: null,
                        codParamCargoGrupSocDirectv: null,
                        nomCatCargoDirectv: null,
                      };
                      setBandejaDirectiva(datos);
                      setDisabledContinue(true);
                    }
                  }}
                />
              )
            )}
          </>
        )}
      </>
    );
  };
  const headerTemplate = (data) => {
    return <span className="font-bold">{data.nomCatTipoGobierno}</span>;
  };

  const footerTemplate = (data) => {
    return <></>;
  };
  return (
    <>
      <div className="card">
        <Observation observationValue={listadoDirectiva?.object?.observacion} />
        <Fieldset toggleable legend="Datos del representante legal" className="mb-4">
          <div className="grid">
            <div className="flex col-12 md:col-3 ">
              <span className="mr-2" style={{ minWidth: "130px", textAlign: "left" }}>
                Tipo de identificación:
              </span>
              <div className="font-medium">{listadoDirectiva?.object?.tipoIdentificacion}</div>
            </div>

            <div className="col-12 md:col-9 ">
              <span className="mr-4">Apellidos y nombres:</span>
              <span className="font-medium">{listadoDirectiva?.object?.nombre}</span>
            </div>
            <div className="flex col-12 md:col-3 ">
              <span
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "130px", textAlign: "left" }}
              >
                Identificación:
              </span>
              <div className="font-medium">{listadoDirectiva?.object?.numIdentificacion}</div>
            </div>
            <div className="flex col-12 md:col-6 ">
              <span
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "130px", textAlign: "left" }}
              >
                Fecha de nombramiento:
              </span>
              <div className="font-medium">
                {listadoDirectiva?.object?.fecNombramiento
                  ? moment(listadoDirectiva?.object?.fecNombramiento).format("DD/MM/YYYY")
                  : ""}
              </div>
            </div>
          </div>
        </Fieldset>

        <DataTable
          className="p-datatable-responsive-demo"
          paginator
          rows={25}
          dataKey="codParamCargoGrupSoc"
          loading={undefined}
          value={bandejaDirectiva}
          rowGroupMode="subheader"
          groupRowsBy="nemCatTipoGobierno"
          expandableRowGroups
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowGroupHeaderTemplate={headerTemplate}
          rowGroupFooterTemplate={footerTemplate}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column field="nomCatCargo" header="Gobierno" headerStyle={{ textAlign: "center" }} />
          <Column
            field="obligatorio"
            header="Obligatorio"
            headerStyle={{ textAlign: "center" }}
            body={(rowData) => (rowData.obligatorio ? "Sí" : "No")}
          />
          <Column
            field="numIdentificacion"
            header="Identificación"
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nombres"
            header="Apellidos y nombres"
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nomCatCargoDirectv"
            header="Directivo"
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            header="Acciones"
            headerStyle={{ textAlign: "center" }}
            bodyStyle={{
              textAlign: "center",
            }}
            body={actionTemplate}
          ></Column>
        </DataTable>
        <div className="flex pt-4 justify-content-between">
          <Button
            type="button"
            label="Actualizar"
            disabled={disabledNext || deshabilitarCampos}
            onClick={() => {
              showLoader();
              dispatch(guardarDirectiva(bandejaDirectiva));
            }}
            icon="pi pi-save"
            className="mr-2"
          />
          <div>
            <Button
              label="Anterior"
              severity="secondary"
              icon="pi pi-arrow-left"
              className="mr-2"
              onClick={() => stepperRef.current.prevCallback()}
            />
            <Button
              label="Continuar"
              icon="pi pi-arrow-right"
              iconPos="right"
              severity="warning"
              disabled={disabledContinue}
              onClick={() => {
                showLoader();
                dispatch(validarDirectiva(codSolConstitucion, codGrupoConstAdec));
              }}
            />
          </div>
        </div>
      </div>
      {modal && (
        <ModalSocios
          modal={modal}
          callbackModal={toggleModal}
          showLoader={showLoader}
          hideLoader={hideLoader}
          dispatch={dispatch}
          callbackSelected={callbackSelected}
          codSolConstitucion={codSolConstitucion}
          toast={toast}
          selectedSocios={selectedSocios}
        />
      )}
      {modalCargo && (
        <RegistrarCargo
          modal={modalCargo}
          callbackModal={toggleModalCargo}
          showLoader={showLoader}
          hideLoader={hideLoader}
          dispatch={dispatch}
          callbackSelected={callbackSelected}
          codSolConstitucion={codSolConstitucion}
          toast={toast}
          codGrupoConstAdec={codGrupoConstAdec}
          cargo={selectedCargo}
          listaExcluir={selectedCargos}
        />
      )}
    </>
  );
};
export default Directiva;
